import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import translation_en from './en.json'
import translation_ms from './ms.json'
import { App_Language_key } from '../config'
 
// // 获取浏览器首选语言
// const getLanguageFn = () => {
//     return navigator.language || navigator.userLanguage
// }
 
const resources = {
  en: {
    translation: translation_en,
  },
  ms: {
    translation: translation_ms,
  },
}
 
// 进行初始化
i18n.use(initReactI18next).init({
  // 我们自己的语言文件
  resources,
  // 默认语言
  lng: sessionStorage.getItem(App_Language_key) === 'ms' ? 'ms' : 'en',
  interpolation: {
    escapeValue: false,// 不会为了xss攻击，而把我们的内容强行转成字符串
  },
})
 
export default i18n
